// eslint-disable-next-line no-restricted-imports
import { asyncWithLDProvider } from 'launchdarkly-react-client-sdk';

import { CurrentUser } from '@qualio/ui-components/lib/types/CurrentUser';

/**
 * Adding a flag here will make it known to the app.  When running locally the
 * value listed here next to the flag is what will be used by calls to "useFlags".
 * When in staging/prod the value will be fetched from LaunchDarkly, but any flag
 * not listed here will not be watched by the LD client
 */
export const LocalFlagConfiguration = {
  issueStepDueDates: true,
  multiSelectEventsList: true,
  additionalEventListFilters: true,
  tasksListSearchBar: true,
  listSavedViews: true,
  configurableColumnsEventList: true,
  eventCollaborators: true,
  emailInstanceSwitch: false,
  dcLinkResourceLibraryProduct: false,
  mtbeNewStagingDomain: false,
} as const satisfies Record<string, boolean>;

export type KnownFlags = keyof typeof LocalFlagConfiguration;
export type FeatureFlagProviderCreator = (user: CurrentUser) => ReturnType<typeof asyncWithLDProvider>;
